
  document.addEventListener('DOMContentLoaded', function () {
    const grids = document.querySelectorAll('.vpv-product-list[data-enable-stagger="true"]');
    if (!grids.length) return;

    function isInView(el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function revealGrid(grid) {
      grid.classList.add('is-visible');
    }

    // Create one observer and use it for all grids that need it
    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealGrid(entry.target);
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.01
    });

    grids.forEach((grid) => {
      if (isInView(grid)) {
        // Already in view on load → reveal immediately
        revealGrid(grid);
      } else {
        // Wait until scrolled into view
        observer.observe(grid);
      }
    });
  });

